import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import Box from "@mui/material/Box";
import "./../style.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import pdficon from "./../Asset/PDF.png";
import csvicon from "./../Asset/CSV.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import fav_icon from "./../Asset/New_Assert/ESO_ICON.png";
import Select from 'react-select';
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";
import KeywordAddForm from "./KeywordAddForm";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PreferredList from "./PreferredList";
import Loader from "../CommonLoader";
import CampaignSettingsList from "./CampaingSettingList";
import { useNavigate, useLocation } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BrandMentions from "./BrandMentions";
import { Helmet } from 'react-helmet';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Keywordbar from "./../Rightsidebar/Keywordbar";
import { ToastContainer, toast } from "react-toastify";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Keywordsuggestion from "../../NavBar/keywordsuggestion/Keywordsuggestion"
import CommonAlert from "../../../Commonalert/commonalert";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import { Link } from "react-router-dom";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid } from '@mui/material';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
// import { styled } from '@mui/material/styles';
// import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useUserActivity } from "../../../hooks/useUserActivity";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import GainedKeywordssvg from "../Asset/esocardicon/RankingComparison/GainedKeywords.svg";
import Commoncard from "../Commoncard";


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function KeywordsList() {
  const location = useLocation();
  const [campTabSelection, setCampTabSelection] = useState('');
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalIsOpens, setIsOpens] = React.useState(false);
  const [modalIsOpenAdd, setIsOpenAdd] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState("");
  const [selectval, setSelectval] = useState("");
  const [selectionModel, setSelectionModel] = useState([]);
  const [dateIsOpen, setdateIsOpen] = React.useState(false);
  const [EditBrandTerm, SetEditBrandTerm] = useState('')
  const [EditBrandMatch, SetEditBrandMatch] = useState('')
  const [EditBrandId, SetEditBrandId] = useState('')

  const [EnableKeywordAddForm, SetEnableKeywordAddForm] = useState(false)

  const [CallPreferredList, SetCallPreferredList] = useState(false)
  const [buttnval, setButtnval] = useState("1")
  const [menubutval, setMenubutval] = useState("1")
  const [pagename, setPagename] = useState("Keywords")
  const [deleteId, SetDeleteId] = useState("")
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [editErr, seteditErr] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Page Load");
  const [commonComponentKey, setCommonComponentKey] = useState(0);

  const [keywordaddpopup, setkeyWordAddPopup] = useState(false);
  const [openBulkKeyPopup, setOpenBulkKeyPopup] = useState(false);

  const [succespopup, setsuccespopup] = useState(null);


  const [freesiteaudit, setfreesiteaudit] = useState({ status: true, error: "" });

  const [freesiteaudit1, setfreesiteaudit1] = useState({ status: true, error: "" });

  const [freesiteaudit2, setfreesiteaudit2] = useState({ status: true, error: "" });

  const [freesiteaudit3, setfreesiteaudit3] = useState({ status: true, error: "" });

  const [submitKeyword, setSubmitKeyword] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);

  const [checkfilter, setCheckFilter] = useState(false);

  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });

  const [tableLoading, setTableLoading] = useState(true);
  const [addSuccessPopup, setAddSuccessPopup] = useState(false);
  const [addSuccessPopupMsg, setAddSuccessPopupMsg] = useState(null);
  const [CampaignList, SetCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [campaignerr, setCampaignerr] = useState("");
  const [keywordFile, setKeywordFile] = useState("Choose File");
  const [bulkKeyError, setBulkKeyError] = useState("");
  const [barChartData, setBarChartData] = useState([]);
  const [totalBrandTerms, setTotalBrandTerms] = useState(0);

  const popupFilter = () => {
    setCheckFilter(true);
  }



  const keywordaddpopupCloseOk = () => {
    setkeyWordAddPopup(false);
  }

  const bulkKeyPopClose = () => {
    setOpenBulkKeyPopup(false);
  }

  const handleReset = () => {
    setSelectedCampaign(null);
    setKeywordFile('Choose File');
  }

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const selectCampKeyword = (campaignId) => {
    faqdatafun('1')
    setMenubutval('1')
    setButtnval('1')
    localStorage.setItem('menu', '1')
    setPagename("Keywords")
    setSelectedMenu('1');
    setCommonComponentKey((prevKey) => prevKey + 1);
    setCampTabSelection(campaignId);
  }

  const menuChange = e => {
    e.preventDefault();
    setfaqData(2)
    setToggle(false)
    faqdatafun(e.target.id)
    setMenubutval(e.target.id)
    setButtnval(e.target.id)
    localStorage.setItem('menu', e.target.id)
    if (e.target.id == 1) {
      setPagename("Keywords")
    } else if (e.target.id == 2) {
      setPagename("Branded Terms")
    }
    else if (e.target.id == 3) {
      // GetCampaignData()
      setPagename("Campaigns")
    }
    else if (e.target.id == 4)
      setPagename("Keyword Suggestion")
    else if (e.target.id == 5)
      setPagename("Brand Mentions")

    setSelectedMenu(e.target.id);
    setCommonComponentKey((prevKey) => prevKey + 1);

  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const navigate = useNavigate();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpens = async (e) => {
    SetDeleteId(e.target.id)
    setIsOpens(true);
  };
  const handleDeleteClick = (id) => {
    SetDeleteId(id);
    setIsOpens(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });


  useEffect(() => {
    faqdatafun();
    GetuserDatavalue();
    if (localStorage.getItem('menu') === '4') {
      setButtnval(localStorage.getItem('menu'));
      setMenubutval(localStorage.getItem('menu'));
    }
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });

      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }

      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setOpenCommonAlerts(true);
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setOpenCommonAlerts(true);
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setOpenCommonAlerts(true);
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };

  const keywordSuggestionTab = () => {
    faqdatafun();
    setkeyWordAddPopup(false);
    setOpenBulkKeyPopup(false);
    setfaqData(2);
    setToggle(false);
    faqdatafun('4');
    setMenubutval('4');
    setButtnval('4');
    localStorage.setItem("menu", '4')
    setPagename("Keyword Suggestion");
  }
  const faqdatafun = async (menubutval = "") => {
    if (menubutval == 1 || menubutval == "")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=1`
    else if (menubutval == 2)
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=2`
    else if (menubutval == 3)
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=3`
    else if (menubutval == 4)
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=61`
    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {

        SetInitialDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const columns = [


    {
      field: "brand_term",
      headerName: "Brand Term Name",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      sortable: true,
      description: 'A brand name was added to the campaign.',

      disableClickEventBubbling: true,
    },
    {
      field: "match",
      headerName: "Match Type",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      sortable: true,
      description: 'A match type was added for the brand term name.',
      disableClickEventBubbling: true,
    },
    {
      field: "edit",
      headerName: "Edit",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        return (
          <Tooltip title={'Click here to edit the brand'}>
            <a className="EditBrandedTermClass" href="javascript:void(0)" data-id={cardData.row.id}>
              <button className="buttonView edit_icon keyword-edit-icon" onClick={EditBrandedTerm}>

                <EditIcon className="edit-icon-svg" />
              </button>
            </a>
          </Tooltip>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        return (
          <Tooltip title={'Click here to delete the brand'}>
            <a className="DeleteBrandedtermClass" href="javascript:void(0)" data-id={cardData.row.id}>
              <button className="buttonView trash_icon keyword-delete-icon"
                onClick={() => handleDeleteClick(cardData.row.id)}
                id={cardData.row.id}>

                <DeleteIcon className="delete-icon-svg" />
              </button>
            </a>
          </Tooltip>
        );
      },
    },
  ];
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const setsuccespopupClose = () => {
    setsuccespopup(null);
    callUserdataApi();
  }

  const setAddSuccesPopupClose = () => {
    setAddSuccessPopup(false);
    setAddSuccessPopupMsg(null);
    // setSubmitKeyword(true);
  }

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "") => {
    setTableLoading(true);
    setLoading(true);
    // setCardData([])
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/v2/brandterm_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data?.result && datavalue?.data?.result?.length > 0) {
        if (datavalue?.data?.result) {
          const newData = datavalue?.data?.result.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          SetAutoheightval(false)
          setCardData(newData);
        }
      }
      else {
        SetAutoheightval(true)
        setCardData("");
      }

      if (datavalue?.data) {
        setBarChartData(datavalue?.data?.bar_chart_data || []);
        setTotalBrandTerms(datavalue?.data?.total_brand_terms || 0)
      }

    } catch (err) {
      console.log(err)
    }

    setTableLoading(false);
    setLoading(false);

  };

  function closeModal() {
    seteditErr("")
    setIsOpen(false);
    setIsOpens(false);
    SetEditBrandErr('')
  }

  const handleEditReset = () => {
    SetEditBrandTerm('');
    SetEditBrandMatch('');
  }

  function openModalAdd() {
    if (first.statusDomain) {
      setcheckD(first.statusDomain);
    } else {
      setIsOpenAdd(true);
    }
  }
  function closeModalAdd() {
    seteditErr("")
    setIsOpenAdd(false);
    SetErrorsAdd([])
    setSelectCampaign([])
  }

  const handelNewReset = () => {
    var examples = document.querySelectorAll(".branded_term");
    examples.forEach(function (example) {
      var textInputs = example.querySelectorAll('input[type="text"]');
      for (var i = 0; i < textInputs.length; i++) {
        // BrandingTermNameArray.push(textInputs[i].value);
        textInputs[i].value = '';
      }
    });
    examples.forEach(function (example) {
      var radioInputs = example.querySelectorAll('input[type="radio"]');

      radioInputs.forEach(function (input) {
        if (input.checked) {
          // BrandingTermMatchArray.push(input.value);
          input.value = '';
          input.checked = false;
        }
      });
    });

  }

  function addbrands() {
    navigate("/add-brands")
  }
  const handleSelectionModelChange = (newSelection) => {


    setSelectionModel(newSelection);


  };
  const handleConfirmDelete = () => {
    DeleteBrandedterm(deleteId);
  };

  const DeleteBrandedterm = async (deleteId) => {
    setIsOpens(false);
    const Id = deleteId
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/brandterm_delete/?user_domain_id=${esodata.domaindata.value.header_selected}&brand_id=${Id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

    } catch (err) {
      console.log(err)
    }


    callUserdataApi()



  }
  const [EditCampaignName, SetEditCampaignName] = useState('')
  const EditBrandedTerm = (e) => {

    SetEditBrandTerm('')
    SetEditBrandMatch('')
    SetEditCampaignName('')

    const Id = e.target.closest(".EditBrandedTermClass").getAttribute("data-id");

    const foundObject = findObjectById(cardData, parseInt(Id));
    SetEditBrandId(parseInt(Id))

    if (foundObject) {
      SetEditBrandTerm(foundObject.brand_term)
      SetEditBrandMatch(foundObject.match)
      SetEditCampaignName(foundObject.category__name)
    }


    setIsOpen(true)



  }

  const [EditBrandErr, SetEditBrandErr] = useState('')

  const SubmitEditBrand = async () => {

    var Err = 0
    SetEditBrandErr('')
    if (EditBrandTerm === '') {

      Err = 1;
      seteditErr("Enter the brand terms")
    }
    if (EditBrandMatch === '') {
      Err = 1;
    }

    if (Err === 0) {

      setLoading(true)


      try {

        const datavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}keywords/brandterm_edit/?user_domain_id=${esodata.domaindata.value.header_selected}&brand_id=${EditBrandId}&brand_term=${EditBrandTerm}&match=${EditBrandMatch}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });

        if (datavalue.data.message) {
          setsuccespopup(datavalue.data.message);
          setIsOpen(false)
          setLoading(false)
          callUserdataApi()
        }

      } catch (err) {
        setLoading(false)
        if (err?.response?.data?.error) {
          SetEditBrandErr(err.response.data.error)
        }
        console.log(err)
      }
    }

  }

  const findObjectById = (array, id) => {
    return array.find(obj => obj.id === id);
  };

  const [CallCampaignTable, SetCallCampaignTable] = useState(false)

  const IncreseBrandIndex = () => {
    const node = document.getElementsByClassName("branded_term")[0];
    var clone = node.cloneNode(true);

    var clonedInputs = clone.querySelectorAll("input");

    var clonedXButton = clone.querySelectorAll(".IncreseBrandIndexClone");
    var clonedInputs = clone.querySelectorAll("input");

    clonedInputs.forEach(function (input) {
      if (input.type === "text") {
        input.value = "";
      } else if (input.type === "radio" || input.type === "checkbox") {
        input.checked = false;
      }
    });
    clonedXButton.forEach(function (button) {
      button.innerHTML = "";
      var xIcon = document.createElement("i");
      xIcon.className = "fa fa-times brandedtermremove";
      button.appendChild(xIcon);
    });

    var parentDiv = document.getElementById("branded_term_clone");
    var elements = parentDiv.querySelectorAll("*");
    var numElements = elements.length;

    clonedInputs.forEach(function (input, index) {
      if (input.type === "radio") {
        input.setAttribute("name", "brand_match[" + (numElements + 1) + "]");
      }
      if (input.type === "text") {
        input.setAttribute(
          "name",
          "brand_match_text_" + (numElements + 1) + ""
        );
      }
    });

    document.getElementById("branded_term_clone").appendChild(clone);
  };


  document.body.addEventListener("click", function (event) {
    if (event.target.classList.contains("brandedtermremove")) {
      var brandedTerm = event.target.closest(".branded_term");
      if (brandedTerm) {
        brandedTerm.remove();
      }
    }
  });

  const GetCampaignData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      const responseData = response?.data;

      const campaigns = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.result)
          ? responseData.result
          : Array.isArray(responseData?.data)
            ? responseData.data
            : [];

      const campaignOptions = campaigns
        .map((campaign) => ({
          label:
            campaign?.campaign_name ||
            campaign?.name ||
            "Unnamed Campaign",

          value:
            campaign?.campaign_id ||
            campaign?.id,
        }))
        .filter((campaign) => campaign.value !== undefined);

      SetCampaignList(campaignOptions);
    } catch (error) {
      console.error("Campaign list error:", error);

      SetCampaignList([]);

      if (
        error?.response?.status === 599 ||
        error?.response?.status === 400 ||
        error?.response?.status === 500
      ) {
        setapiOpen(true);
        setapierrorMsg(
          error?.response?.data?.error ||
          "Unable to load campaigns"
        );
      } else if (
        error?.code === "ERR_NETWORK" ||
        error?.response?.status === 404
      ) {
        navigate("/errorpages");
      }
    }
  };


  // const [campaigndata, Setcampaigndata] = useState([])
  const [SelectCampaign, setSelectCampaign] = useState([])
  // const GetCampaignData = async () => {


  //   Setcampaigndata([])

  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}keywords/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,

  //       {
  //         headers: {
  //           Authorization: `${ApiToken}`,
  //         },
  //       }
  //     ).catch((error) => {
  //       if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
  //         setapiOpen(true);
  //         setapierrorMsg(error?.response?.data?.error)
  //       }
  //       else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
  //         navigate('/errorpages')
  //       }
  //     });
  //     if (response?.data) {
  //       var Sections = [];
  //       response.data.forEach((element) => {
  //         Sections.push({
  //           label: element.campaign_name,
  //           value: element.campaign_id,
  //         });
  //       });
  //       SetCampaignList(Sections);

  //       Setcampaigndata(response.data)
  //     }


  //   } catch (err) {
  //     console.log(err)
  //   }



  // }
  const addKeywordform = () => {
    navigate('/add-keyword');
  }

  const [ErrorsAdd, SetErrorsAdd] = useState([])

  const SaveBrand = async () => {

    SetErrorsAdd([])

    var BrandingTermNameArray = [];
    var BrandingTermMatchArray = [];
    var BrandingMergeArray = [];
    var examples = document.querySelectorAll(".branded_term");
    examples.forEach(function (example) {
      var textInputs = example.querySelectorAll('input[type="text"]');
      for (var i = 0; i < textInputs.length; i++) {
        BrandingTermNameArray.push(textInputs[i].value);
      }
    });

    var examples = document.querySelectorAll(".branded_term");

    examples.forEach(function (example) {
      var radioInputs = example.querySelectorAll('input[type="radio"]');

      radioInputs.forEach(function (input) {
        if (input.checked) {
          BrandingTermMatchArray.push(input.value);
        }
      });
    });

    if (BrandingTermNameArray.length === BrandingTermMatchArray.length) {
      BrandingTermNameArray.forEach((element, index) => {
        BrandingMergeArray.push({
          term: BrandingTermNameArray[index],
          match: BrandingTermMatchArray[index],
        });
      });
    }

    var Err = 0;

    var EArray = [];

    if (Err == 1) {

      EArray.push({
        message: 'Please select campaign name'
      })

    }

    if (BrandingMergeArray.length === 0) {
      Err = 2;
    }

    if (Err == 2) {
      EArray.push({
        message: 'Enter the brand terms and choose matching type'
      })
    }

    SetErrorsAdd(EArray)


    if (Err === 0) {

      try {

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}keywords/add_brandterm/`,
          {
            user_domain_id: `${esodata.domaindata.value.header_selected}`,
            brand_terms: BrandingMergeArray
          },
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });

        if (response.data) {
          setsuccespopup(response.data.message);
          callUserdataApi()
          closeModalAdd()
        }

      } catch (err) {

        if (err.response) {
          if (err.response.data) {
            if (err.response.data.errors) {
              SetErrorsAdd(err.response.data.errors)
            }
          }
        }


        console.log(err)
      }

    }
  }


  const pdfdown = async (campId) => {
    setLoading(true);
    setIsDownloading(true);
    try {
      if (pagename == "Keywords")
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/keyword_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&campaign_id=${campId ?? ''}`;
      else if (pagename == "Branded Terms")
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/brandterm_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf`;
      else
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf`;
      const response = await fetch(
        pdfname,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        }
      );

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        if (pagename == "Keywords")
          var filedata = await Commonfun("Keywords", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        else if (pagename == "Branded Terms")
          var filedata = await Commonfun("Brandedterm", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        else
          var filedata = await Commonfun("Campaign", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };
  const csvdown = async (campId) => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      // if (pagename == "Keywords" && campId)
      //   var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/keyword_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&campaign_id=${campId}`;
      if (pagename == "Keywords")
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/keyword_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&campaign_id=${campId ?? ''}`;
      else if (pagename == "Branded Terms")
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/brandterm_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv`;
      else
        var pdfname = `${process.env.REACT_APP_API_URL}keywords/v2/campaign_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv`;
      const response = await fetch(
        pdfname,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        }
      );

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        if (pagename == "Keywords")
          var filedata = await Commonfun("Keyword", "csv", ApiToken, esodata.domaindata.value.header_selected);
        else if (pagename == "Branded Terms")
          var filedata = await Commonfun("Brandedterm", "csv", ApiToken, esodata.domaindata.value.header_selected);
        else
          var filedata = await Commonfun("Campaign", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  };

  // const tabName = menubutval==='1' ? 'keywords' : menubutval==='2' ? 'brandterms' : 'campaigns';

  // useUserActivity(tabName);

  const freeAudit = async () => {

    if (menubutval === "1") {
    } else if (menubutval === "2") {
      // useUserActivity('brandterms');
    } else if (menubutval === "3") {
      // useUserActivity('campaigns');
    } else if (menubutval === "4") {
      // useUserActivity('dashboard');
    }
    const check = await Utils("keywords", ApiToken);
    const check1 = await Utils("brand_terms", ApiToken);
    const check2 = await Utils("campaigns", ApiToken);
    const check3 = await Utils("keyword_suggestion", ApiToken);

    setfreesiteaudit(check);
    setfreesiteaudit1(check1);
    if (check.status && menubutval === "1") {
      // GetCampaignData();
    }
    if (check1.status && menubutval === "2") {
      callUserdataApi();
    }
    setfreesiteaudit2(check2);
    setfreesiteaudit3(check3);


  }


  useEffect(() => {
    freeAudit();
  }, [menubutval])


  const regionalsetting = () => {
    if (first.statusDomain) {
      setcheckD(first.statusDomain);
    } else {
      navigate('/regional-level-settings');
    }
  }

  const [checkingD, setcheckingD] = useState(false);

  const addcampaign = () => {

    if (first.statusDomain) {
      setcheckD(first.statusDomain);
    } else {
      setcheckingD(true);
    }
  }


  const adkeyw = () => {
    if (first.statusDomain) {
      setcheckD(first.statusDomain);
    } else {
      setkeyWordAddPopup(true);
    }
  }

  const bulkKeyPopOpen = async () => {
    if (first.statusDomain) {
      setcheckD(first.statusDomain);
      return;
    }

    setCampaignerr("");
    setSelectedCampaign(null);
    setOpenBulkKeyPopup(true);

    await GetCampaignData();
  };

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  // const submitBulkKeyword = async () => {
  //   if (!selectedCampaign) {
  //     setCampaignerr("This field is required");
  //   }
  //   if (!keywordFile) return;

  //   const formData = new FormData();
  //   formData.append("user_domain_id", esodata.domaindata.value.header_selected);
  //   formData.append("campaign_id", selectedCampaign.value);
  //   formData.append("file", keywordFile); // "file" is the key the backend expects
  //   console.log('formdata', formData)

  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}keywords/bulk_add_keywords/?user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${selectedCampaign.value}`, {
  //       method: "POST",
  //       body: formData,
  //       // Don't set Content-Type manually; browser will set it
  //     },
  //       {
  //         headers: {
  //           Authorization: `${ApiToken}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });
  //     const data = await response.json();
  //     console.log("Success:", data);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };


  const submitBulkKeyword = async () => {
    setLoading(true);
    // e.preventDefault();
    let err = 1;
    if (!selectedCampaign) {
      setLoading(false);
      setCampaignerr("This field is required");
      err = 2;
    }
    if (keywordFile == "Choose File") {
      setLoading(false);
      setBulkKeyError('Please select a file to upload')
      err = 2;
    }
    if (bulkKeyError === '' && err === 1) {

      // e.preventDefault();
      const formData = new FormData();
      formData.append('user_domain_id', esodata.domaindata.value.header_selected);
      formData.append("campaign_id", selectedCampaign.value);
      formData.append('file', keywordFile, keywordFile.name);
      try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}keywords/bulk_add_keywords/?user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${selectedCampaign.value}`,
          formData,
          {
            headers: {
              Authorization: `${ApiToken}`,
              'Content-Type': 'multipart/form-data',
            },

          }).catch((error) => {
            setLoading(false);
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error)
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
              navigate('/errorpages')
            }
          });
        if (res?.data?.message) {
          setSubmitKeyword(true);
          setLoading(false);
          setKeywordFile(null);
          setKeywordFile("Choose File");
          setOpenBulkKeyPopup(false);
          // setsuccespopup(res.data.message);
          setAddSuccessPopup(true);
          setAddSuccessPopupMsg(res.data.message);
        }

      } catch (error) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }

    }
    else {
      setLoading(false);
      if (keywordFile == "Choose File") {
        setBulkKeyError('Please select a file to upload')
        return;
      } else {
        setBulkKeyError('Please upload a CSV file');
        return false;
      }
    }
    setLoading(false);

  };

  const downloadBuldKeyFormat = async (e) => {
    e.preventDefault(); // prevent page reload
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}keywords/template_download/?download=true`,
        {
          method: "GET",
          headers: {
            // "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const filedata = await Commonfun(
          "Builkeyword Template",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected
        );
        link.download = filedata;

        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        // handle errors
      }
    } catch (error) {
      console.error("Error during download:", error);
    }
  };

  const fileInputRef = useRef(null);
  const handleDivClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const onFileChange = (event) => {
    setLoading(true);
    const selectedFile = event.target.files[0];
    const validExtensions = ['.csv'];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
      if (validExtensions.includes(`.${fileExtension}`)) {
        setKeywordFile(selectedFile);
        setBulkKeyError('');
        setLoading(false);
      } else {
        setKeywordFile(selectedFile);
        setBulkKeyError('Please upload a CSV file');
        setLoading(false);
      }
    }
  };

  const cardDatas = [
    {
      value: totalBrandTerms || 0,
      title: "total Brand Terms",
      iconSrc: GainedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
    }

  ];


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Keywords</title>
      </Helmet>
      {
        loading === true ? <Loader /> : null
      }


      {/* <Container maxWidth={false} sx={{ maxWidth: "1500px" }} className="title_" style={{ marginTop: "30px", marginBottom: "30px" }}>
        <Box style={{ background: "#fff", borderRadius: "50px", padding: "0px 20px 0px 20px" }}>
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={6}>
              <div><h1 className="dashboard_header">{pagename} <span
                  style={{ cursor: "pointer", color: "rgb(11 32 51)", backgroundColor: "rgba(255, 96, 31, 0.2)", padding: "0px 6px", borderRadius: "4px", fontSize: "13px", fontWeight: "500" }}
                  onClick={handleToggle}
                >
                  FAQ's
                </span></h1>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Keywords' },
                      { title: 'Targeted Keywords' },
                      { title: menubutval === "1" ? 'Keywords' : menubutval === "2" ? 'Branded Terms' : menubutval === "3" ? 'Campaigns' : 'Keyword Suggestion', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  {pagename}
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb
                      breadcrumbValue={[
                        { title: 'Keywords' },
                        { title: 'Targeted Keywords' },
                        {
                          title:
                            menubutval === "1"
                              ? 'Keywords'
                              : menubutval === "2"
                                ? 'Branded Terms'
                                : menubutval === "3"
                                  ? 'Campaigns'
                                  : 'Keyword Suggestion',
                          activeColor: true,
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                {menubutval === "1" &&
                  <div className="drop_down_button">
                    <button
                      className="btn_dashboard"
                      onClick={bulkKeyPopOpen}
                      disabled={!freesiteaudit.status}
                    >
                      Add Bulk Keyword
                    </button>
                    <button
                      className="btn_dashboard"
                      onClick={adkeyw}
                      disabled={!freesiteaudit.status}
                    >
                      Add Keywords
                    </button>
                  </div>
                }
                {menubutval === "2" && <button
                  className="btn_dashboard"
                  disabled={!freesiteaudit1.status}
                  onClick={() => {
                    openModalAdd();
                  }}
                >
                  Add Brands
                </button>
                }
                {menubutval === "3" &&
                  <>
                    <button className="btn_dashboard" disabled={!freesiteaudit.status} onClick={addcampaign} >
                      Add Campaign
                    </button>
                    <button
                      className="btn_dashboard"
                      onClick={regionalsetting}
                      disabled={!freesiteaudit.status}
                    >
                      Regional Level Settings
                    </button>
                  </>
                }
                {menubutval === "4" && <button
                  className="btn_dashboard"
                  onClick={freesiteaudit3.status ? popupFilter : null}
                  disabled={!freesiteaudit.status}
                >
                  Generate SEO Keywords
                </button>
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <div className="">
        <div className="">
          {/* {menubutval === "1" && <Typography sx={{ color: '#ff601f', textDecoration: 'none' }}>Keywords</Typography>}
            {menubutval === "2" && <Typography sx={{ color: '#ff601f', textDecoration: 'none' }}>Branded Terms</Typography>}
            {menubutval === "3" && <Typography sx={{ color: '#ff601f', textDecoration: 'none' }}>Campaigns</Typography>}
            {menubutval === "4" && <Typography sx={{ color: '#ff601f', textDecoration: 'none' }}>Keyword Suggestion</Typography>} */}
          {/* <CommonBreadCrumb breadcrumbValue={[
            { title: 'Keywords' },
            { title: 'Targeted Keywords' },
            { title: menubutval === "1" ? 'Keywords' : menubutval === "2" ? 'Branded Terms' : menubutval === "3" ? 'Campaigns' : 'Keyword Suggestion', activeColor: true }
          ]} /> */}
          {/* <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon className="faq_icons" />

            </button>
            {freesiteaudit.status && menubutval === "1" &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
            {freesiteaudit1.status && menubutval === "2" &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
            {freesiteaudit2.status && menubutval === "3" &&
              <>
              
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown}  />
              </>
            }
          </div> */}
          {toggle && (
            <Keywordbar
              close={() => setToggle(false)} setToggle={setToggle}
              initialDateval={initialDateval}
            />
          )}
        </div>
        {/* <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f", display: 'flex' }}>
              {pagename}
            </h2>
          </div>

          {menubutval === "1" && <button
            className="runreportnew"
            onClick={adkeyw}
            disabled={!freesiteaudit.status}
          >
            Add Keywords
          </button>
          }


          {menubutval === "2" && <button
            className="runreportnew"
            disabled={!freesiteaudit1.status}
            onClick={() => {
              openModalAdd();
            }}
          >
            Add Brands
          </button>
          }

          {menubutval === "3" &&
            <>
              <button className="runreportnew" disabled={!freesiteaudit.status} onClick={addcampaign} >
                Add Campaign
              </button>
              <button
                className="runreportnew"
                onClick={regionalsetting}
                disabled={!freesiteaudit.status}
              >
                Regional Level Settings
              </button>
            </>
          }
          {menubutval === "4" && <button
            className="runreportnew"
            onClick={freesiteaudit3.status ? popupFilter : null}
            disabled={!freesiteaudit.status}
          >
            Generate SEO Keywords
          </button>
          }

        </div> */}

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="trendy-tabs-wrapper">
                  <div className="trendy-tab-container">
                    <button
                      type="button"
                      id={1}
                      className={`trendy-tab ${buttnval === "1" ? "active" : ""}`}
                      onClick={(e) => menuChange(e)}
                    >
                      Keywords
                    </button>
                    <button
                      type="button"
                      id={2}
                      className={`trendy-tab ${buttnval === "2" ? "active" : ""}`}
                      onClick={(e) => menuChange(e)}
                    >
                      Branded Terms
                    </button>

                    <button
                      type="button"
                      id={3}
                      className={`trendy-tab ${buttnval === "3" ? "active" : ""}`}
                      onClick={(e) => menuChange(e)}
                    >
                      Campaigns
                    </button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>




        {menubutval === "1" ? (
          <>
            {EnableKeywordAddForm === true ? (
              <div className="keyword_add_form">
                <KeywordAddForm
                  SetEnableKeywordAddForm={SetEnableKeywordAddForm}
                  CallCampaignTable={CallCampaignTable}
                  SetCallCampaignTable={SetCallCampaignTable}
                  SetCallPreferredList={SetCallPreferredList}
                  setAddSuccessPopup={setAddSuccessPopup}
                  setAddSuccessPopupMsg={setAddSuccessPopupMsg}
                  setSubmitKeyword={setSubmitKeyword}
                />
              </div>
            ) : null}

            {freesiteaudit.status && freesiteaudit.status ? <PreferredList
              CallPreferredList={CallPreferredList}
              SetCallPreferredList={SetCallPreferredList}
              submitKeyword={submitKeyword}
              setSubmitKeyword={setSubmitKeyword}
              csvdown={csvdown}
              pdfdown={pdfdown}
              campTabSelection={campTabSelection}
            /> : <Freeaudit planStatus={freesiteaudit} />}

            {/* <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} /> */}
            <UserActivityTracker pagename="Keywords - Targeted Keywords - Keywords" />
          </>
        ) : null}




        {menubutval === "2" &&
          <>
            {/* <Container maxWidth={false} className="dashboard-card-container">
              <Box >
                <Grid container spacing={2} className="dashboard-box-card">
                  <Grid container spacing={3} xs={12} sm={12} md={4} justifyContent="center">

                  </Grid>
                </Grid>
              </Box>
            </Container> */}

            <Container maxWidth={false} className="dashboard-container">
              <Grid container spacing={2} style={{ marginBottom: '20px', alignItems: 'center' }}>

                <Grid container spacing={3} xs={12} sm={12} md={4} justifyContent="center" height={170}>
                  {cardDatas.map((item, index) => (
                    <Grid item xs={12} sm={12} md={12} key={item.id}>
                      <Commoncard
                        item={item}
                        nonclikable={true}
                      />
                    </Grid>
                  ))}
                </Grid>

                <Grid item xs={12} md={8}>
                  <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Brand Terms by Match Type</Typography>
                    <Chart
                      type="bar"
                      height={240}
                      series={[{
                        name: "Count",
                        data: (barChartData || []).map(i => i?.term_count || 0)
                      }]}
                      options={{
                        chart: { toolbar: { show: false } },
                        plotOptions: {
                          bar: {
                            horizontal: false,
                            columnWidth: '45%',
                            borderRadius: 4,
                            distributed: true, // 👈 IMPORTANT
                            dataLabels: { position: 'top' }
                          }
                        },
                        colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                        dataLabels: {
                          enabled: true,
                          offsetY: -20,
                          style: { fontSize: '12px' }
                        },
                        xaxis: {
                          categories: (barChartData || []).map(i => i?.match.length > 20 ? i?.match.slice(0, 25) + "..." || "" : i?.match || ""),
                          position: 'bottom',
                          labels: {
                            offsetX: 50,
                            style: { fontSize: '11px' }
                          }
                        },
                        yaxis: {
                          title: { text: 'Count' },
                          labels: { formatter: (val) => Math.floor(val) }
                        },
                        noData: { text: "No Metric Data Available" }
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
              <Box className="grid_table_shodow">
                <Grid container className="dashboard-grid">
                  <Grid item xs={12} md={12}>
                    <div className="cnt_audit_outer_wrap">
                      {freesiteaudit1.status && freesiteaudit1.status ?
                        <DatagridComp className="datagrid_custom_scroll"
                          columns={columns}
                          rows={rows}
                          autoheightval={autoheightval}
                          datagridval={2}
                          columnFreezeWidth={[0]}
                          tableLoading={tableLoading}
                          DownloadShowPDF={1}
                          DownloadShowCSV={2}
                          DownloadShowFile={true}
                          handleDownlodingCSV={handleDownlodingCSV}
                          handleDownlodingPDF={handleDownlodingPDF}
                        /> : <Freeaudit planStatus={freesiteaudit1} />}
                      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Container>

            <Container maxWidth={false} className="footer-container">
              <Box className="footer-box">
                <Grid container className="footer-grid">
                  <Grid item xs={12} md={6}>
                    <div className="footer-left">
                      <p className="footer-text">
                        All Rights Reserved Copyright © 2026 |
                        <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                      </p>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="footer-right">
                      <p>{/* Add content if needed */}</p>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Container>
            <UserActivityTracker pagename="Keywords - Targeted Keywords - Brand Terms" />
          </>

        }

        {menubutval === "3" ? (
          <>
            {freesiteaudit2.status && freesiteaudit2.status ?
              <CampaignSettingsList
                Auditstatus={freesiteaudit2}
                EnableKeywordAddForm={EnableKeywordAddForm}
                SetEnableKeywordAddForm={SetEnableKeywordAddForm}
                CallCampaignTable={CallCampaignTable}
                SetCallCampaignTable={SetCallCampaignTable}
                handleDownlodingCSV={handleDownlodingCSV}
                // GetCampaignData={GetCampaignData}
                checkingD={checkingD} setcheckingD={setcheckingD}
                csvdown={csvdown}
                pdfdown={pdfdown}
                selectCampKeyword={selectCampKeyword}
              /> : <Freeaudit planStatus={freesiteaudit2} />}
            {/* <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} /> */}
            <UserActivityTracker pagename="Keywords - Targeted Keywords - Campaigns" />
          </>
        ) : null}
        {menubutval === "4" ? <Keywordsuggestion Auditstatus={freesiteaudit3} checkfilter={checkfilter} setCheckFilter={setCheckFilter} /> : null}

        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter keyword_edit_form"
        >
          <DialogTitle className="keyword-dialog-header">{"Edit Brand Term"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                <div>

                  <div className="colhead brandhead">
                    <span className="col12">Branded Term :</span>
                    <div className="col21">
                      <input
                        type="text"
                        className="dropdown_height"
                        defaultValue={EditBrandTerm}
                        value={EditBrandTerm}
                        onChange={(e) => {
                          SetEditBrandTerm(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="errs" style={{ color: "red" }}>{editErr}</div>
                  <div className="keyword_edit_form_match_row">
                    <span>Match Type: </span>
                    <div style={{ display: "flex", gap: "15px" }}>
                      <div>
                        <input
                          type="radio"
                          name="match_type"
                          value={"phrase"}
                          checked={
                            EditBrandMatch === "phrase" ? true : false
                          }
                          onChange={(e) => {
                            SetEditBrandMatch(e.target.value);
                          }}
                        />
                        Phrase Match
                      </div>
                      <div>
                        <input
                          type="radio"
                          name="match_type"
                          value={"exact"}
                          checked={EditBrandMatch === "exact" ? true : false}
                          onChange={(e) => {
                            SetEditBrandMatch(e.target.value);
                          }}
                        />
                        Exact Match
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="err">{EditBrandErr}</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button
              className="keyword-submit"
              style={{ marginTop: "auto" }}
              onClick={SubmitEditBrand}
            >
              Submit
            </button>
            <button className="keyword-cancel" onClick={closeModal}>
              Close
            </button>
            <button className="keyword-cancel" onClick={handleEditReset}>
              Reset
            </button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={modalIsOpenAdd}
          onClose={closeModalAdd}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter keyword_edit_form brand_term_add_form"
        >
          <DialogTitle className="keyword-dialog-header">{"Add Brand Term"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                <div className="form-inner_brands">
                  <div className="branded_term">
                    <div className="row addbranded_terms">
                      <div className="colhead brandhead">
                        <span className="col12">Branded Term :</span>
                        <div className="col21 frm_container">
                          <input
                            name="brand_match_text_0"
                            className=""
                            type="text"
                            placeholder="Enter Branded Term"
                          />
                        </div>
                      </div>

                      {/* <div style={{ marginLeft: '15px', marginTop: '1rem', alignContent: 'center' }}> */}
                      <div style={{ marginLeft: '15px' }}>
                        <label>Match type:</label>
                        <div className="colhead inputhead" style={{ marginTop: '5px' }}>
                          <div>
                            <div>
                              <input
                                type="radio"
                                name="brand_match[]"
                                value={"phrase"}
                              />
                              <span>Phrase Match</span>
                            </div>
                            <div>
                              <input
                                // style={{ marginLeft: '20px' }}
                                type="radio"
                                name="brand_match[]"
                                value={"exact"}
                              />
                              <span>Exact Match</span>
                            </div>
                          </div>
                          <span
                            className="IncreseBrandIndexClone BrandMatchPlus"
                            onClick={IncreseBrandIndex}
                          >
                            <AddIcon />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="branded_term_clone"></div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          {ErrorsAdd.map((item) => (
            <div className="err" style={{ marginLeft: "20px" }}>{item.message}</div>
          ))}

          <DialogActions className="dialog-action-button">
            <button
              className="keyword-submit"
              style={{ marginTop: "auto" }}
              onClick={SaveBrand}
            >
              Submit
            </button>
            <button className="keyword-cancel" onClick={closeModalAdd}>
              Close
            </button>
            <button className="keyword-cancel resetBtn" onClick={() => {
              handelNewReset();
              document.getElementById('branded_term_clone').innerHTML = '';
            }}>
              Reset
            </button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={modalIsOpens}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                Are you sure you want to delete the Brand Term Name?
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button
              className="form_submit_btn"
              onClick={handleConfirmDelete}
              style={{ cursor: "pointer" }}
            >
              OK
            </button>
            <button style={{ cursor: "pointer" }} onClick={closeModal}>
              close
            </button>
          </DialogActions>
        </Dialog>


        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
        <Dialog
          open={keywordaddpopup}
          onClose={keywordaddpopupCloseOk}
          PaperProps={{
            className: 'keyword-dialog',
          }}
        >
          <DialogTitle className="keyword-dialog-header">{"Add Keywords"}</DialogTitle>
          <DialogContent className="update-user-dialog">
            <KeywordAddForm
              setkeyWordAddPopup={setkeyWordAddPopup}
              keywordSuggestionTab={keywordSuggestionTab}
              setSubmitKeyword={setSubmitKeyword}
              setAddSuccessPopup={setAddSuccessPopup}
              setAddSuccessPopupMsg={setAddSuccessPopupMsg}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={openBulkKeyPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Add Bulk Keyword</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <form>
                <div className="keyword-col1-fields">
                  <div>
                    <label for="city" style={{ marginLeft: 'auto' }}>
                      Campaign Name :
                    </label>
                    <Select
                      name="campaign"
                      options={CampaignList}
                      value={selectedCampaign}
                      onChange={(selectedOption) => {
                        setSelectedCampaign(selectedOption);
                        setCampaignerr("");
                      }}
                      placeholder={
                        CampaignList.length > 0
                          ? "Select Campaign"
                          : "No campaigns available"
                      }
                      isDisabled={CampaignList.length === 0}
                      isLoading={loading}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      classNamePrefix="addkeyword"
                    />
                  </div>
                  <div>
                    {" "}
                    <span className="error-value">{campaignerr}</span>
                  </div>
                </div>
                <div className="keyword-col1-fields" style={{ marginBottomBottom: '0px' }}>

                  <label for="city" style={{ paddingBottom: '5px' }}>
                    Upload File :
                  </label>
                  <form className="fileform" style={{ justifyContent: "space-between" }}>
                    {/* <div className='upload-container'>
                      <label
                        htmlFor="file-input"
                        className="upload-label"
                        onClick={(e) => {
                          handleDivClick(e);
                        }}
                      >
                        Select File
                      </label>
                      <input
                        id="file-input"
                        type="file"
                        className="field-style"
                        style={{ display: 'contents' }}
                        ref={fileInputRef}
                        accept=".csv"
                        onChange={onFileChange}
                      />

                      {keywordFile &&
                        <p className="file-info" style={{ borderRadius: "0px 10px 10px 0px" }}>
                          {keywordFile?.name?.length > 8 ?
                            keywordFile.name.slice(0, 5) + '...' : keywordFile.name}
                        </p>}
                    </div> */}

                    <div className="upload-container">
                      <label style={{ borderRadius: "4px" }}
                        htmlFor="file-input"
                        className="upload-label"
                        onClick={(e) => {
                          handleDivClick(e);
                        }}
                      >
                        <CloudUploadIcon style={{ marginRight: "6px" }} />
                        Select File
                      </label>

                      <input
                        id="file-input"
                        type="file"
                        className="field-style"
                        style={{ display: 'contents' }}
                        ref={fileInputRef}
                        accept=".csv"
                        onChange={onFileChange}
                      />

                      {keywordFile &&
                        <p className="file-info" style={{ borderRadius: "0px", padding: "0px", border: "0px solid #ccc", position: "absolute", bottom: "100px", color: " #4CAF50;", background: "#e9e9e9" }}>
                          {keywordFile?.name?.length > 8 ?
                            keywordFile.name.slice(0, 25) + '...' : keywordFile.name}
                        </p>}
                      {/* {keywordFile?.name && (
    <p className="file-info" >
      {keywordFile.name} 
    </p>
  )} */}
                    </div>

                    <button type="button" className="blubutton" style={{ borderRadius: "4px", flexBasis: "auto" }} onClick={(e) => { e.preventDefault(); downloadBuldKeyFormat(e); }}>Sample Template</button>
                  </form>
                  <div>
                    <span className="error-value">{bulkKeyError}</span>
                  </div>
                </div>
              </form>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => submitBulkKeyword()}>Submit</Button>
            <Button onClick={() => bulkKeyPopClose()} >Close</Button>
            <Button onClick={() => handleReset()} >Reset</Button>
          </DialogActions>
        </Dialog>

        <CommonErrorAlert
          data={{
            apiopen: succespopup,
            apiErrorMsg: succespopup,
            isIconStyled: false
          }}
          closeAlert={setsuccespopupClose} />
        <CommonErrorAlert
          data={{
            apiopen: addSuccessPopup,
            apiErrorMsg: addSuccessPopupMsg,
            isIconStyled: false
          }}
          closeAlert={setAddSuccesPopupClose} />

        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
                <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
            <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
          </DialogActions>
        </Dialog>

      </div>


    </div>
  );
}
